import api from './api'

// A base do axios já inclui /api — paths NÃO levam /api (senão vira /api/api/...).
export const deviceAuthApi = {
  getDeviceInfo: (userCode) =>
    api.get(`/auth/device/info/${encodeURIComponent(userCode)}`).then((r) => r.data),

  approveDevice: (userCode) =>
    api.post('/auth/device/approve', { userCode }).then((r) => r.data),
}
